// extracted by mini-css-extract-plugin
module.exports = {"container":"DemoAuth_container__1zMRd","emailField":"DemoAuth_emailField__2xaAV","form":"DemoAuth_form__3Gt5j","logo":"DemoAuth_logo__1l8yy","button":"DemoAuth_button__ZucgK"};